import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { Zap, AlertCircle, CheckCircle2, Users } from 'lucide-react';

const ExpeditedOptions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/processing-times')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Processing Times
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Expedited Processing Options
          </h1>
          <p className="text-muted-foreground">
            Learn about available options for faster processing of your residence permit application.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Zap className="h-5 w-5 text-primary mr-2" />
                Priority Processing Categories
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Blue Card Holders:</span> Highly qualified specialists with job contracts
                  </div>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Strategic Investors:</span> Business owners creating jobs in Poland
                  </div>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Academic Staff:</span> University professors and researchers
                  </div>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Family Reunification:</span> Spouses and children of Polish citizens
                  </div>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Users className="h-5 w-5 text-primary mr-2" />
                Professional Assistance
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Legal representation services
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Immigration consultants
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Document preparation services
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Translation and certification services
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Important Considerations
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Expedited processing is not guaranteed
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Additional fees may apply for certain services
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Documentation must still be complete and accurate
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Some options may vary by voivodeship
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Need Professional Assistance?</h2>
            <p className="text-muted-foreground mb-4">
              Our team can help evaluate your eligibility for expedited processing and connect you with qualified legal representatives.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Get Expert Help
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpeditedOptions; 